import { render, staticRenderFns } from "./InvoicesAndQuotesDashboard.vue?vue&type=template&id=5095ebf2"
import script from "./InvoicesAndQuotesDashboard.vue?vue&type=script&lang=js"
export * from "./InvoicesAndQuotesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports